// extracted by mini-css-extract-plugin
export default {"loader":"QueryBuilderDialog_loader__TV07n"};